/** Logo image size as a fraction of the badge, when a call site does not pass its own. */
export const CREST_LOGO_SIZE_RATIO = 0.72;

/**
 * How far to zoom the flag asset so its flag *card* fills the round badge.
 *
 * Our CDN flags (`assets/Flags/<code>.webp`) are not bare flags: each is a 500x500 canvas
 * holding a rounded flag card on a near-transparent crosshatch. Measured on `eu.webp`, that
 * card is 347x233 centred, so drawing the asset at badge size fills barely a third of the
 * circle and reads as a smudge. 500/233 is what makes the card's short side cover the badge;
 * every flag in the set shares the layout, so the ratio is not EU-specific.
 */
export const CREST_FLAG_CARD_ZOOM = 500 / 233;

/** Monogram text size as a fraction of the badge (44px badge → 12px, the pre-slice value). */
export const CREST_MONOGRAM_SIZE_RATIO = 0.27;

export const COMPETITION_CREST_TEST_IDS = {
  logo: 'competition-crest-logo',
  flag: 'competition-crest-flag',
  monogram: 'competition-crest-monogram',
} as const;
